import {
  Component,
  Inject,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

export interface data {
  id: number;
  confirm_icon: string;
  confirm_text: string;
  confirm_class: string;
  show_cancel: boolean;
  cancel_icon: string;
  cancel_text: string;
  cancel_class: string;
  show_third_btn: boolean;
  third_btn_icon: string;
  third_btn_text: string;
  third_btn_class: string;
  title: string;
  text: string;
  body_title?: string;
  icon: string;
}
@Component({
  selector: 'app-confirmation-pop-up',
  templateUrl: './confirmation-pop-up.component.html',
  styleUrls: ['./confirmation-pop-up.component.scss']
})
export class ConfirmationPopUpComponent {
  public dialogData: data;
  constructor(
    public dialogRef: MatDialogRef<ConfirmationPopUpComponent>,
    @Inject(MAT_DIALOG_DATA) public data: data,
    private translateService: TranslateService
  ) {
    this.dialogData = Object.assign(
      {},
      {
        id: +new Date(),
        confirm_icon: null,
        confirm_text: this.translateService.instant('common.confirm'),
        confirm_class: 'danger-btn',
        show_cancel: true,
        cancel_icon: null,
        cancel_text: this.translateService.instant('common.cancel'),
        cancel_class: '',
        show_third_btn: false,
        third_btn_icon: null,
        third_btn_text: '',
        third_btn_class: '',
        text: this.translateService.instant('common.confirmation_message'),
        icon: null,
      },
      data
    );
  }

  ngOnInit(): void {}

  closeTicket() {
    this.dialogRef.close(true);
  }

  thirdAction() {
    this.dialogRef.close('third');
  }

  cancel() {
    this.dialogRef.close(false);
  }
}
